import React, { useEffect } from 'react';
import './InstagramEmbed.css';

const InstagramEmbed: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.src = '//www.instagram.com/embed.js';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    
    <div className="instagram-embed-container" style={{ maxWidth: '60px', margin: 'auto' }}>
      <blockquote
        className="instagram-media"
        data-instgrm-captioned
        data-instgrm-permalink="https://www.instagram.com/reel/DGdkroMvpnU/?utm_source=ig_embed&amp;utm_campaign=loading"
        data-instgrm-version="14"
        style={{
          background: '#FFF',
          border: '0',
          borderRadius: '3px',
          boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
          margin: '1px',
          maxWidth: '100%',
          minWidth: '326px',
          padding: '0',
          width: '100%',  // You can control this width
        }}
      >
        <div style={{ padding: '16px' }}>
          <a
            href="https://www.instagram.com/reel/DGdkroMvpnU/?utm_source=ig_embed&amp;utm_campaign=loading"
            style={{
              background: '#FFFFFF',
              lineHeight: '0',
              padding: '0 0',
              textAlign: 'center',
              textDecoration: 'none',
              width: '100%',
            }}
            target="_blank"
            rel="noopener noreferrer"  // Added security measure
          >
            {/* Content goes here */}
          </a>
        </div>
      </blockquote>
      <script async src="//www.instagram.com/embed.js"></script>
    </div>

    
  );
};

export default InstagramEmbed;
